import { Card } from "flowbite-react";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { getPerformance } from "../../api/performance";

const Performance = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchCampaign = async () => {
      try {
        const _performance = await getPerformance();

        setData(_performance);
      } catch (error) {
        console.error(error);
        toast.error('Error fetching performance data');
      }
    }

    fetchCampaign();
  }, []);

  if (!data) return null;

  return (
    <>
      <div className="flex gap-2 justify-between items-center border-b border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-800 sm:flex">
        <h1 className="text-xl font-semibold text-gray-900 dark:text-white sm:text-2xl">Performance</h1>
      </div>
      <div className="p-4">
        <Card>
          <div className="flex flex-col gap-4">
            <p><span className="font-bold">Running campaigns:</span> {data?.campaigns || 0}</p>
            <p><span className="font-bold">Number of influencers in all campaigns:</span> {data?.influencers || 0}</p>
            <p><span className="font-bold">Number of emails sent:</span> {data?.emailsSent || 0}</p>
            <p><span className="font-bold">Number of replies received:</span> {data?.repliesReceived || 0}</p>
            <p><span className="font-bold">Number of positive responses:</span> {data?.escalated || 0}</p>
          </div>
        </Card>
      </div>
    </>
  );
}

export default Performance;
